import $store from '@/store'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { TabError } from '@/utils/class/TabError'
import checkPermission from '@/utils/permission'
import { getUserInfo } from '@/utils/auth'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import { cacheKeys, getFilterCacheList, getObjectByCache } from '@/utils/basicDataCache'
import { getJobByUuid } from '@/api/booking/job'
import i18n from '@/lang'
import { getUserRoleByPrivilege } from '@/api/user'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { cache } from '@/utils/cacheManager'

export class SecurityUtil {
  // 红冲修改费用字段检查
  static dataFields = ['customerId', 'bookingAgent', 'designationAgent', 'customsBroker', 'warehouseCmp', 'carrierId']
  /**
   * 判断当前用户是否可以编辑这票单子
   */
  static async canEdit(job, isRefreshJob = true) {
    if (RateUtil.useOrderCenterMode() && (job.cooperateStatus !== undefined && job.cooperateStatus !== null && job.cooperateStatus !== -1)) {
      return true
    }
    //
    if (isRefreshJob) {
      await getJobByUuid(job.uuid).then(res => {
        const newJob = res.data
        if (newJob) {
          for (const key in newJob) {
            if (typeof job[key] === 'object' || !newJob[key]) {
              continue
            }
            job[key] = newJob[key]
          }
        }
      }).catch()
    }
    console.log('job===', job)
    const user = getUserInfo()
    const userId = user.userId
    if (user.admin || checkPermission(['role_editAllBusiness'])) {
      return true
    }
    const isCsrEditJob = checkPermission(['role_csrEditJob'])
    if (Number(job.op) === userId || (Number(job.csr) === userId && isCsrEditJob) || Number(job.dc) === userId || Number(job.userDefinedRoleId1) === userId || Number(job.userDefinedRoleId2) === userId || Number(job.cargoSalesId) === userId ||
        Number(job.userDefinedRoleId3) === userId || Number(job.userDefinedRoleId4) === userId || Number(job.userDefinedRoleId5) === userId || Number(job.userDefinedRoleId6) === userId || Number(job.userDefinedRoleId7) === userId) {
      return true
    }
    if (checkPermission(['role_salesEditJob']) && (Number(job.sales) === userId || Number(job.createdBy) === userId)) {
      return true
    }
    if (checkPermission(['role_plannerEditJob']) && Number(job.planner) === userId) {
      return true
    }
    // CARGO-31800 新增现场操作、卡车客服编辑权限
    if (checkPermission(['role_siteOpEditJob']) && Number(job.siteOp) === userId) {
      return true
    }
    if (checkPermission(['role_truckCsrEditJob']) && Number(job.truckCsr) === userId) {
      return true
    }
    if (Number(job.overseaOp) === userId) {
      return true
    }
    if (job.lob === 'AE') {
      if (Number(job.overseaOp) === userId || Number(job.planner) === userId) {
        return true
      }
    }
    if (job.lob === 'RE' || job.lob === 'RI') {
      if (Number(job.overseaOp) === userId) {
        return true
      }
      if (Number(job.cargoSalesId) === userId) {
        return true
      }
    }
    return await this.hasDepartmentEdit(job)
  }
  /**
   * 是否有同组编辑权限
   */
  static async hasDepartmentEdit(job) {
    const departments = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
      return item.officeUuid === $store.getters.currentOfficeUuid
    })
    let flag = false
    const roles = await getUserRoleByPrivilege({ 'category': 'role', 'shape': 'DepartmentEdit' }).then(res => res.data)
    if (departments && departments.length > 0) {
      for (const dep of departments) {
        if (this.isDepartmentEdit(dep, job)) {
          if (roles && roles.length > 0) {
            for (const role of roles) {
              if (role.departmentId > 0 && role.departmentId === dep.departmentId) {
                flag = true
                break
              }
            }
          }
        }
      }
    }
    return flag
  }
  /**
   * 同组编辑权限(操作，客服，销售，航线)
   */
  static isDepartmentEdit(dep, job) {
    if (dep.departmentId === Number(job.opDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.csrDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.salesDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.dcDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.cargoSalesDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept1)) { // 自定义岗位1 同组编辑
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept2)) { // 自定义岗位2 同组编辑
      return true
    }
    // 自定义岗位3-7
    if (dep.departmentId === Number(job.userDefinedRoleDept3)) {
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept4)) {
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept5)) {
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept6)) {
      return true
    }
    if (dep.departmentId === Number(job.userDefinedRoleDept7)) {
      return true
    }
    // CARGO-31800 新增现场操作、卡车客服编辑权限
    if (dep.departmentId === Number(job.siteOpDepartment)) {
      return true
    }
    if (dep.departmentId === Number(job.truckDept)) {
      return true
    }
    if (job.lob === 'AE' && dep.departmentId === Number(job.overseaOpDepartment)) {
      return true
    }
    if (job.lob === 'SE') {
      if (dep.departmentId === Number(job.plannerDepartment)) {
        return true
      }
      if (dep.departmentId === Number(job.overseaOpDepartment)) {
        return true
      }
    }
    if (job.lob === 'RE' || job.lob === 'RI') {
      if (dep.departmentId === Number(job.overseaOpDepartment)) {
        return true
      }
      if (dep.departmentId === Number(job.plannerDepartment)) {
        return true
      }
    }
    if (job.lob === 'AE') {
      if (dep.departmentId === Number(job.plannerDepartment)) {
        return true
      }
    }
    return false
  }

  /**
   * 是否有指定角色同组编辑权限
   */
  static async hasSpecificDepartmentEdit(job, roleMap) {
    const departments = getFilterCacheList(cacheKeys.basic_data_Department, (item) => {
      return item.officeUuid === $store.getters.currentOfficeUuid
    })
    let flag = false
    const roles = await getUserRoleByPrivilege({ 'category': 'role', 'shape': 'DepartmentEdit' }).then(res => res.data)
    if (departments && departments.length > 0) {
      for (const dep of departments) {
        if (this.isSpecificDepartmentEdit(dep, job, roleMap)) {
          if (roles && roles.length > 0) {
            for (const role of roles) {
              if (role.departmentId > 0 && role.departmentId === dep.departmentId) {
                flag = true
                break
              }
            }
          }
        }
      }
    }
    return flag
  }

  /**
   * 指定角色同组编辑权限(操作，客服，销售，航线)
   */
  static isSpecificDepartmentEdit(dep, job, roleMap) {
    console.log('roleMap is', roleMap)
    console.log('roleMap.dc is', roleMap.dc)
    if (roleMap.op && dep.departmentId === Number(job.opDepartment)) {
      return true
    }
    if (roleMap.dc && dep.departmentId === Number(job.dcDepartment)) {
      return true
    }
    return false
  }

  static async canOPEditWithAlert(job) {
    if (job.jobState !== 0) {
      throw new ErrorTip(i18n.t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
    }
    if (await this.canEdit(job)) {
      return true
    }
    throw new ErrorTip(i18n.t('queryJob.OperationOfTicketCannotEdited'))
  }

  /**
   * 合作伙伴是否被禁用
   */
  static async companyisActive(title, cmpIdx, tabName, tagName) {
    const company = await Company.getCompanyById(cmpIdx)
    if (company && !company.active) {
      // REQ-0005：屏蔽提示带上停用原因（inactiveReason 为空时省略）
      const name = tagName ? company[tagName] : (company.chineseName || company.englishName)
      const reason = company.inactiveReason
      const msg = reason
        ? i18n.t('queryJob.CompanyBlockedCannotUsedWithReason').replace('{0}', name).replace('{1}', reason)
        : i18n.t('queryJob.CompanyBlockedCannotUsed').replace('{0}', name)
      throw new TabError(title + msg, tabName)
    }
    return true
  }

  /**
   * 是否必须录入费用
   */
  static checkSaveCharge(flag, job, isBookingFeeMandatoryAppliedGlobally = false) {
    if (!flag || (job.uuid && !job.lclMasterUuid)) {
      return true
    }
    // 开了参数，业务状态 非待审核或者拒绝，就不验证
    if (isBookingFeeMandatoryAppliedGlobally && ![-1, 12].includes(job.jobState)) {
      return true
    }
    const hasChargeView = checkPermission(['tab_Charge_chargeView'])
    const hasChargeReceivable = checkPermission(['tab_Charge_chargeReceivable']) // 应收
    const hasChargePayable = checkPermission(['tab_Charge_chargePayable']) // 应付
    if (hasChargeView && hasChargeReceivable && hasChargePayable && !job.masterFlag && !this.isLCL(job)) {
      if (job.estimateGrossProfit <= 0.0 && (!this.checkReceivableCharge(job.charges) || !this.checkPayCharge(job.charges))) {
        if (this.checkShowTips(job)) {
          throw new ErrorTip(i18n.t('CargoMsg.Cargo_ARAPItemsMustBeComplete'))
        }
      }
    }
    if (!hasChargeView || (!hasChargeReceivable && !hasChargePayable)) {
      return true
    }
    if (job.estimateGrossProfit <= 0.0 && (hasChargeReceivable && !job.masterFlag)) {
      if (!this.checkReceivableCharge(job.charges) && this.checkShowTips(job)) {
        throw new ErrorTip(i18n.t('queryJob.ReceivableExpensesMustBeEntered'))
      }
    }
    if (job.estimateGrossProfit <= 0.0 && (hasChargePayable && !this.isLCL(job) || (hasChargePayable && job.masterFlag))) {
      if (!this.checkPayCharge(job.charges) && this.checkShowTips(job)) {
        throw new ErrorTip(i18n.t('queryJob.PayableExpensesMustBeEntered'))
      }
    }
    return true
  }

  // CARGO-5980 在编辑时 业务中【预估收入】【预估成本】【预估利润】【预估备注】有任一字段不为0或不为空的，不提示“xx费用必须录入”
  static checkShowTips(job) {
    return !(job != null && job.uuid && (job.estimateAccountsPayable !== 0 || job.estimateGrossProfit !== 0 ||
        job.estimateAccountsReceivable !== 0 || (job.situation !== '' && job.situation != null)))
  }

  /**
   * 应收费用
   */
  static checkReceivableCharge(charges) {
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        if (charge.receivable) {
          return true
        }
      }
    }

    return false
  }

  /**
   * 应付费用
   */
  static checkPayCharge(charges) {
    if (charges && charges.length > 0) {
      for (const charge of charges) {
        if (!charge.receivable) {
          return true
        }
      }
    }
    return false
  }

  // /**
  //  * 校验费用金额
  //  */
  // public static function checkChargeAmount(job: Job): void {
  //   const charges: ArrayCollection = new ArrayCollection()
  //   for each(const charge: Charge in job.charges) {
  //     if (charge.amount != 0) {
  //       charges.addItem(charge)
  //     }
  //   }
  //   job.charges = charges
  // }

  /**
   * 小票拼箱不需要判断必须录入应付费用
   */
  static isLCL(job) {
    if (job.lob === 'SE' && job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
      return true
    }
    if (job.lob === 'SI' && job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
      return true
    }
    if (job.lob === 'AE' && (job.lclMasterUuid || job.operateType === AirExportConstants.CONSOLE.code)) {
      return true
    }
    if (job.lob === 'AI' && (job.lclMasterUuid || job.operateType === AirExportConstants.CONSOLE.code)) {
      return true
    }
    return false
  }

  // /**
  //  * （改单）红冲状态为正常的费用,不允许修改委托单位
  //  */
  // public static function checkOffsetChargeJob(job: Job) {
  //   const isOffset = true
  //   if (job == null || !job.isAmendment || job.isNewInstance())
  //     return isOffset

  //   for each(const str in dataFields)
  //   {
  //     isOffset = checkedJobdataField(job, str)
  //     if (!isOffset)
  //       break
  //   }
  //   return isOffset
  // }

  /**
   * 是否允许修改
   */
  static checkOffsetAutoCompleteEnabled(job, dataField) {
    if (!job || !job.amendment || !job.uuid) {
      return true
    }
    return this.isExistOffsetCharge(job.charges, job[dataField])
  }

  // private static function checkedJobdataField(job: Job, dataField) {
  //   const isOffset = isExistOffsetCharge(job.charges, job[dataField])
  //   if (!isOffset) {
  //     switch (dataField) {
  //       case "customerId":
  //         {
  //           MessageDialog.warning("委托单位已经存在费用,不允许修改.")
  //           break
  //         }
  //       case "bookingAgent":
  //         {
  //           MessageDialog.warning("订舱代理已经存在费用,不允许修改.")
  //           break
  //         }
  //       case "designationAgent":
  //         {
  //           MessageDialog.warning("指定货代理已经存在费用,不允许修改.")
  //           break
  //         }
  //       case "customsBroker":
  //         {
  //           MessageDialog.warning("报关行已经存在费用,不允许修改.")
  //           break
  //         }
  //       case "warehouseCmp":
  //         {
  //           MessageDialog.warning("仓库已经存在费用,不允许修改.")
  //           break
  //         }
  //       case "carrierId":
  //         {
  //           MessageDialog.warning("船公司已经存在费用,不允许修改.")
  //           break
  //         }
  //       default:
  //         {
  //           break
  //         }
  //     }
  //   }
  //   return isOffset
  // }

  /**
   * 是否已经存在费用
   */
  static isExistOffsetCharge(charges, accountId) {
    for (const charge of charges) {
      if (charge.accountId === accountId && charge.offsetState === 0) {
        return false
      }
    }
    return true
  }

  // /**
  //  * 修改计费体积、计费重量是否已经存在费用 ,有则不允许修改
  //  */
  // public static function checkOffsetChargeMeasure(job: Job, measure) {
  //   if (job == null || !job.isAmendment || job.isNewInstance())
  //     return true

  //   return checkChargeMeasure(job.charges, measure)
  // }

  // /**
  //  * @private
  //  */
  // private static function checkChargeMeasure(charges: ArrayCollection, measure) {
  //   for each(const charge: Charge in charges)
  //   {
  //     if (charge.measure == measure) {
  //       return false
  //     }
  //   }
  //   return true
  // }

  /**
   * 创建财务结算费用所属分公司校验
   * chargeOffice数据结构暂时未获取parentOffice，只有parentOffice的uuid
   */
  static async checkChargeDetailBranch(branchId) {
    const currentOfficeId = $store.getters.currentOfficeId
    const chargeOffice = await Office.getOfficeById(branchId)
    let parentOffice = null
    if (chargeOffice) {
      parentOffice = await Office.getOfficeByUuid(chargeOffice.parentBranchUuid)
    }
    return (branchId === currentOfficeId || (parentOffice && currentOfficeId === parentOffice.officeId))
  }
  /**
   * 修改计费体积、计费重量是否已经存在费用 ,有则不允许修改
   */
  static checkOffsetChargeMeasure(job, dataField) {
    if (!job || !job.amendment || !job.uuid) {
      return true
    }
    return this.checkChargeMeasure(job.charges, job[dataField])
  }

  static checkChargeMeasure(charges, measure) {
    for (const charge of charges) {
      if (charge.measure === measure) {
        return false
      }
    }
    return true
  }

  /**
   * 校验费用所属分公司是否和当前分公司一致或费用所属分公司的上级分公司等于当前分公司
   * @param branchId
   * @returns {boolean|null}
   */
  static checkChargeBranch(branchId) {
    const currentOfficeId = $store.getters.currentOfficeId
    if (branchId === currentOfficeId) { // 费用分公司和当前分公司一致，直接返回true
      return true
    } else {
      // 默认是一致的
      let res = true
      const chargeOffice = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', branchId)
      if (chargeOffice) {
        if (chargeOffice.parentBranchUuid) { // 有上级分公司，判断上级分公司和当前分公司是否一致
          const parentOffice = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'uuid', chargeOffice.parentBranchUuid)
          res = parentOffice && currentOfficeId === parentOffice.officeId
        } else {
          res = false
        }
      }
      return res
    }
  }

  /**
   * 判断客户是否属于当前登录的分公司
   *
   * CARGO-46172 保存校验委托单位所属分公司逻辑调整
   * 新增参数：业务保存时委托单位校验范围
   * 可选值（缺省值：0）：0.所属分公司 1.所属分公司+应用分公司（满足其一）
   * 当参数=0时（目前逻辑）：委托单位校验 当前分公司= 所属分公司+HQ
   * 当参数=1时（调整逻辑）：委托单位校验 当前分公司=（所属分公司+HQ+应用分公司）满足其一
   *
   * @param data 当前客户cmpIdx
   * @returns {boolean}
   */
  static customerIsOwn(data) {
    // 获取当前分公司
    const currentBranchId = $store.getters.currentOfficeId
    const currentCustomer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', data)
    // 分公司为空直接返回false
    if (!currentCustomer) {
      return false
    }

    // 获取配置参数 如果加载为空 就赋值为0走原本的处理逻辑
    let configFlag = 0
    try {
      configFlag = Number(cache.config.get('bookingSaveCheckBranch'))
    } catch (e) {
      console.log('读取【bookingSaveCheckBranch】失败  error:', e)
    }

    if (configFlag === 1) {
      // 委托单位校验 当前分公司=（所属分公司+HQ+应用分公司）满足其一
      return currentCustomer.branchId === currentBranchId || currentCustomer.branchId === 1 || SecurityUtil.containValue(currentCustomer.multipleBranchId, currentBranchId)
    } else {
      // 0.所属分公司 1.所属分公司+应用分公司（满足其一）
      return currentCustomer.branchId === currentBranchId || currentCustomer.branchId === 1
    }
  }

  /**
   * 处理字符串multipleBranchId 是否包含某个值
   * @param data
   */
  static containValue(data, value) {
    if (!data) {
      return false
    }
    try {
      const arr = data.split(',')
      // 是否包含value
      return arr.indexOf(String(value)) !== -1
    } catch (e) {
      return false
    }
  }
}
